module.exports = __webpack_public_path__ + "img/kr-product-content1-img-1.8ad3699.png";